import { apiClient } from '@/api/client';
import type { MusicTutorProfileData, UpdateMusicTutorProfileRequest } from '@/types/api';

interface MusicProfileResponse {
  success: true;
  data: MusicTutorProfileData | null;
}

export const getMusicTutorProfile = async () => {
  const response = await apiClient.get<MusicProfileResponse>('/profiles/tutor/services/music');
  return response.data.data;
};

export const updateMusicTutorProfile = async (request: UpdateMusicTutorProfileRequest) => {
  const response = await apiClient.put<MusicProfileResponse>('/profiles/tutor/services/music', request);
  return response.data.data;
};

export const submitMusicTutorProfile = async () => {
  const response = await apiClient.post<MusicProfileResponse>('/profiles/tutor/services/music/submit');
  return response.data.data;
};
